import { IFreckle } from '../../repositories/dailyrent/entities/freckle/Freckle';
import { IFrecklesFeaturesMap } from '../../types/freckles';

export const convertFrecklesToFeaturesMap = (freckles: IFreckle[]): IFrecklesFeaturesMap => {
  return freckles.reduce((acc, f) => {
    const id = String(Math.random());

    return {
      ...acc,
      [id]: {
        id,
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [f.coordinates.lat, f.coordinates.lng],
        },
        properties: { pinColor: 'red' },
      },
    };
  }, {});
};
